import { capitalize } from '../../../util/helpers/Strings';

// For legacy organizations
export const tableauOrganizationLegacyMapping = {
  1: 'CrossChannel-Example', // Bluelabs main
  10: 'CrossChannel-FLSD18-Example', // Florida Dems
  20: 'CrossChannelAnalysis-CongressionalDemo', // DLCC
};

// Try the mapping on ID first, if nothing, default to:
// CrossChannel-OrganizationName-Report
// ex: CrossChannel-BlueLabs-Report
export const getCrossChannelTableauForOrganization = (organization) => {
  if (tableauOrganizationLegacyMapping[organization.id]) {
    return tableauOrganizationLegacyMapping[organization.id];
  }

  const organizationWorkbookName = capitalize(organization.name)
                                    .replace(' ', '');

  return `CrossChannel-${organizationWorkbookName}-Report`;
};
